export default __webpack_public_path__ + "static/media/right-arrow.84f05fab.svg";